/*
 Entry point for the library.
 */
import setupApp from './setupApp';

window.addEventListener('load', setupApp);
